class DiscountUpsell extends HTMLElement {
  constructor() {
    super();
    this.upsellProductVariantId = parseInt(this.dataset.upsellProductVariantId);
    this.minCartTotal = parseInt(this.dataset.minCartTotal) * 100;
    this.parentProductPrice = parseInt(this.dataset.parentProductPrice);
    this.discountUpsellModalOpen = false;
  }

  connectedCallback() {
    this.attachEventListeners();

    document.addEventListener('cart:increased', (e) => {
      this.toggleVisibility(e.detail.cart);
    });
  }

  attachEventListeners() {
    document.addEventListener('click', (e) => {
      if (!this.isConnected) return;

      if (e.target.closest('[data-close-cart]') && this.discountUpsellModalOpen || 
        e.target.closest('[data-variant-id]') && this.discountUpsellModalOpen || 
        e.target.closest('overlay-element') && this.discountUpsellModalOpen) {
        this.close();
        return;
      }
    });
  }

  async toggleVisibility(cart) {
    if (cart.item_count < 1 || cart.items.filter(item => item.id === this.upsellProductVariantId).length > 0) {
      this.close();
      return
    }

    if (cart.total_price >= this.minCartTotal || this.parentProductPrice >= this.minCartTotal ) {
      this.removeAttribute('hidden');
      this.setAttribute('open', '');
      this.setAttribute('active', '');
      this.discountUpsellModalOpen = true;
    } else {
      this.close();
    }
  }

  close() {
    this.setAttribute('hidden', '');
    this.removeAttribute('open');
    this.removeAttribute('active');
    this.discountUpsellModalOpen = false;
  }
}

customElements.define('discount-upsell', DiscountUpsell);